// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".houseingRes[data-v-7172208e] .avue-crud__menu{display:none}.cell-color[data-v-7172208e]{color:#409eff!important;cursor:pointer}[data-v-7172208e] .el-table th.is-leaf{padding-left:15px;padding-right:15px}", ""]);
// Exports
module.exports = exports;
